import { useState, useEffect } from 'react';

// Components
import InputText from '../../InputText';

// Styles
import styles from '../../index.module.sass';

export default function Personal({ contractFields, handleChange, t, typecontract }) {
  const [birthdayFocused, setBirthdayFocused] = useState(false);

  function handleBirthdayFocus() {
    document.getElementById('birthday').focus();
    setBirthdayFocused(true);
  }

  useEffect(() => {
    if (contractFields?.birthday) setBirthdayFocused(true);
  }, [contractFields]);

  return (
    <div className={`${styles.personal}`}>
      <div className={styles.areaName}>
        <i className={`material-icons-outlined ${styles.titleIcon}`}>portrait</i>
        {t('personalInformation')}
      </div>
      <div className={styles.areaContainer}>
        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            onChange={handleChange}
            value={contractFields?.nombre || ''}
            requiredText={t('required')}
            type='text'
            placeholder={`${t('name')}*`}
            name='nombre'
            maxLength='44'
            required
          />
        </div>
        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type='text'
            placeholder={`${t('lastName')}*`}
            className={styles.inputText}
            onChange={handleChange}
            name='paterno'
            maxLength='39'
            value={contractFields?.paterno || ''}
            requiredText={t('required')}
            required
          />
        </div>

        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type='date'
            placeholder={`${t('birthday')}*`}
            className={styles.inputText}
            onChange={(e) => handleChange(e)}
            name='birthday'
            id='birthday'
            maxLength='34'
            value={contractFields?.birthday || ''}
            requiredText={t('required')}
            onFocus={() => setBirthdayFocused(true)}
            onBlur={() => {
              if (!contractFields?.birthday) setBirthdayFocused(false);
            }}
            required
          />
          {!birthdayFocused && (
            <div className={styles.floatingLabel} onClick={() => handleBirthdayFocus()}>
              {t('birthday')}*
            </div>
          )}
        </div>

        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <select
            className={styles.inputText}
            onChange={(e) => handleChange(e)}
            name='sexo'
            maxLength='34'
            value={contractFields?.sexo || ''}>
            <option value=''>{t('selectGender')}</option>
            <option value='1'>{t('female')}</option>
            <option value='2'>{t('male')}</option>
            <option value='3'>{t('other')}</option>
          </select>
        </div>

        {/* {typecontract !== 'prefillus' && (
          <div className={`${styles.inputContainer} ${styles.width50}`}>
            <InputText
              type='text'
              placeholder={`${t('socialNumber')}`}
              className={styles.inputText}
              onChange={handleChange}
              name='rfc'
              maxLength='11'
              value={contractFields?.rfc || ''}
            />
          </div>
        )} */}
      </div>
    </div>
  );
}
